
import { Component, Prop, Vue } from "vue-property-decorator";
import RelayGraphKey from "@/components/relays/RelayGraphKey.vue";

@Component({
  components: { RelayGraphKey },
})

export default class RelayStats extends Vue {

  @Prop({ default: null })
  public relay: any;

  private relayKeysStats: any = [];

  private mounted() {
    this.$store.dispatch("relays/getKeyStatsById", {
      id: this.relay.id,
    }).then((data) => {
      this.relayKeysStats = data;
    });
  }
}
